import axios from "axios";
import { getLocalStorage } from "../helpers/get-set-local-storage";
import { store } from "../../store/store";
import { setMessage } from "../../store/slices/Notification";
import { localStorageConstants } from "../constants/localStorageConstants";
import { clearStoreAndLogout } from "../helpers/authHelper";
import { bikes24JavaApi, javaAPI } from "../constants/organizationConstants";

export const baseURL = process.env.REACT_APP_API_PATH;
export const baseURLJava = process.env.REACT_APP_CAMPAIGN_BASE_URL_JAVA;
export const basePlatformURL = process.env.REACT_APP_PLATFROM_URL;
export const baseUrlBikes24 = "https://cms-bike-backend.qac24svc.dev";

export const createUrl = (endpoint: string, onlyNodeServer: boolean = false) => {
  let orgId = getLocalStorage(localStorageConstants.ORG_ID);
  if (onlyNodeServer) return baseURL + endpoint;
  return (
    (!onlyNodeServer && javaAPI.includes(orgId)
      ? baseURLJava
      : bikes24JavaApi.includes(orgId)
      ? baseUrlBikes24
      : baseURL) + endpoint
  );
};

export const createUrlNew = (endpoint: string) => {
  const usePlatformURL = basePlatformURL;

  return (usePlatformURL ? basePlatformURL : "") + endpoint;
};

const axiosInstance = axios.create({
  timeout: 15000,
  headers: {
    "Content-Type": "application/json",
    "ngrok-skip-browser-warning": "69420",
  "x-api-key": "f638a1f3b574",
  },
});

axiosInstance.interceptors.request.use(
  (config: any) => {
    const token = getLocalStorage(localStorageConstants.TOKEN);
    let orgId = getLocalStorage(localStorageConstants.ORG_ID);
    let role = getLocalStorage(localStorageConstants.ROLE);
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    if (orgId) {
      config.headers.tenantId = `${orgId}`;
    }
    if (role) {
      config.headers.role = `${role}`;
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

axiosInstance.interceptors.response.use(
  (response: any) => {
    return response;
  },
  (error) => {
    if (error?.response && (error?.response?.status === 401 || error?.response?.status === 403)) {
      if (error.response.data.path !== "/api/v1/auth/login") {
        window.location.href = "/";
      }
      clearStoreAndLogout();
    }
    if (error.response && error.response.data.statusCode === 404) {
      store.dispatch(
        setMessage({
          type: "error",
          message: "Resource not found. Please check your request.",
        })
      );
    }
    if (error.response && error.response.data.statusCode === 500) {
      store.dispatch(
        setMessage({
          type: "error",
          message: "Internal Server Error",
        })
      );
    }
    return Promise.reject(error);
  }
);

export default axiosInstance;
